export const links = [
    {
        "nombre" : "Transparencia",
        "link" : "/Transparencia",
        "submenu" : [
            {
                "subMenuNombre" : "48 Rubros",
                "subMenuUrl" : "/Transparencia/Rubros"
            },
 {
                 "subMenuNombre" : "Rubros Anteriores",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
 },

  {
                 "subMenuNombre" : "MIR",
                "subMenuUrl" : "/MIR"
 }
        ]
        
    },
  {
        "nombre" : "SISTEMA DE GESTIÓN DE CALIDAD",
        "link" : "/Calidad",
        
    },
{
        "nombre" : "Trámites y Servicios",
        "link" : "/Tramites",
    },

    {
        "nombre" : "SCII",
        "link" : "/Scii",
        
    },



   

]